import ShippingFee from '..'

import FixedShippingFee from '../fixed-shipping-fee'
import { containsFreeShippingItem } from '../free-shipping-item'

import { CartItem } from '../../cart/cart-item'

import BehaviorConfig from '@/models/app-config/behavior/behavior'

/**
 * 適用する送料を選択するストラテジクラス
 */
export default class SelectShippingFee {
  public static createWithBehaviorConfig(
    totalPrice: number,
    behaviorConfig: BehaviorConfig,
    cartItems: CartItem[]
  ): SelectShippingFee {
    return new SelectShippingFee(
      behaviorConfig.fixShippingFee(totalPrice),
      cartItems
    )
  }

  public static create(
    brandShippingFee: ShippingFee,
    cartItems: CartItem[]
  ): SelectShippingFee {
    return new SelectShippingFee(brandShippingFee, cartItems)
  }

  constructor(
    private brandShippingFee: ShippingFee,
    private cartItems: CartItem[]
  ) {}

  /**
   * 通常送料を上書きする固定送料を選択
   */
  selectFixedFee(): ShippingFee {
    if (containsFreeShippingItem(this.cartItems)) {
      return new FixedShippingFee(0)
    }

    return this.brandShippingFee
  }
}
